module.exports = __webpack_public_path__ + "static/media/east tower shot 01-mobile.1b27741b.webp";